import * as ambassadorWixOnlineProgramsParticipantsV3JoinApplication from './online-programs-participants-v3-join-application-join-applications.http.js';
import * as ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes from './online-programs-participants-v3-join-application-join-applications.types.js';
import * as ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes from './online-programs-participants-v3-join-application-join-applications.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createJoinApplication(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.CreateJoinApplicationRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.CreateJoinApplicationRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.CreateJoinApplicationResponse,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.CreateJoinApplicationResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixOnlineProgramsParticipantsV3JoinApplication.createJoinApplication(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/join-applications',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getJoinApplication(): __PublicMethodMetaInfo<
  'GET',
  { joinApplicationId: string },
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.GetJoinApplicationRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.GetJoinApplicationRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.GetJoinApplicationResponse,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.GetJoinApplicationResponse
> {
  const payload = { joinApplicationId: ':joinApplicationId' } as any;

  const getRequestOptions =
    ambassadorWixOnlineProgramsParticipantsV3JoinApplication.getJoinApplication(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/join-applications/{joinApplicationId}',
    pathParams: { joinApplicationId: 'joinApplicationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteJoinApplication(): __PublicMethodMetaInfo<
  'DELETE',
  { joinApplicationId: string },
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.DeleteJoinApplicationRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.DeleteJoinApplicationRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.DeleteJoinApplicationResponse,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.DeleteJoinApplicationResponse
> {
  const payload = { joinApplicationId: ':joinApplicationId' } as any;

  const getRequestOptions =
    ambassadorWixOnlineProgramsParticipantsV3JoinApplication.deleteJoinApplication(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v3/join-applications/{joinApplicationId}',
    pathParams: { joinApplicationId: 'joinApplicationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryJoinApplications(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.QueryJoinApplicationsRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.QueryJoinApplicationsRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.QueryJoinApplicationsResponse,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.QueryJoinApplicationsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixOnlineProgramsParticipantsV3JoinApplication.queryJoinApplications(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/join-applications/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function searchJoinApplications(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.SearchJoinApplicationsRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.SearchJoinApplicationsRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.SearchJoinApplicationsResponse,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.SearchJoinApplicationsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixOnlineProgramsParticipantsV3JoinApplication.searchJoinApplications(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/join-applications/search',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateJoinApplications(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.BulkCreateJoinApplicationsRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.BulkCreateJoinApplicationsRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.BulkCreateJoinApplicationsResponse,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.BulkCreateJoinApplicationsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixOnlineProgramsParticipantsV3JoinApplication.bulkCreateJoinApplications(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/join-applications/create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteJoinApplications(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.BulkDeleteJoinApplicationsRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.BulkDeleteJoinApplicationsRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.BulkDeleteJoinApplicationsResponse,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.BulkDeleteJoinApplicationsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixOnlineProgramsParticipantsV3JoinApplication.bulkDeleteJoinApplications(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/join-applications/delete',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getCurrentJoinApplication(): __PublicMethodMetaInfo<
  'GET',
  { programId: string },
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.GetCurrentJoinApplicationRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.GetCurrentJoinApplicationRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.GetCurrentJoinApplicationResponse,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.GetCurrentJoinApplicationResponse
> {
  const payload = { programId: ':programId' } as any;

  const getRequestOptions =
    ambassadorWixOnlineProgramsParticipantsV3JoinApplication.getCurrentJoinApplication(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/join-applications/current/{programId}',
    pathParams: { programId: 'programId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function myJoinApplication(): __PublicMethodMetaInfo<
  'GET',
  { programId: string },
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.MyJoinApplicationRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.MyJoinApplicationRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.MyJoinApplicationResponse,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.MyJoinApplicationResponse
> {
  const payload = { programId: ':programId' } as any;

  const getRequestOptions =
    ambassadorWixOnlineProgramsParticipantsV3JoinApplication.myJoinApplication(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/join-applications/my/{programId}',
    pathParams: { programId: 'programId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function approveJoinApplication(): __PublicMethodMetaInfo<
  'POST',
  { joinApplicationId: string },
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.ApproveJoinApplicationRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.ApproveJoinApplicationRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.ApproveJoinApplicationResponse,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.ApproveJoinApplicationResponse
> {
  const payload = { joinApplicationId: ':joinApplicationId' } as any;

  const getRequestOptions =
    ambassadorWixOnlineProgramsParticipantsV3JoinApplication.approveJoinApplication(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/join-applications/{joinApplicationId}/approve',
    pathParams: { joinApplicationId: 'joinApplicationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function declineJoinApplication(): __PublicMethodMetaInfo<
  'POST',
  { joinApplicationId: string },
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.DeclineJoinApplicationRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.DeclineJoinApplicationRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.DeclineJoinApplicationResponse,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.DeclineJoinApplicationResponse
> {
  const payload = { joinApplicationId: ':joinApplicationId' } as any;

  const getRequestOptions =
    ambassadorWixOnlineProgramsParticipantsV3JoinApplication.declineJoinApplication(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/join-applications/{joinApplicationId}/decline',
    pathParams: { joinApplicationId: 'joinApplicationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function cancelJoinApplication(): __PublicMethodMetaInfo<
  'POST',
  { joinApplicationId: string },
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.CancelJoinApplicationRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.CancelJoinApplicationRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.CancelJoinApplicationResponse,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.CancelJoinApplicationResponse
> {
  const payload = { joinApplicationId: ':joinApplicationId' } as any;

  const getRequestOptions =
    ambassadorWixOnlineProgramsParticipantsV3JoinApplication.cancelJoinApplication(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/join-applications/{joinApplicationId}/cancel',
    pathParams: { joinApplicationId: 'joinApplicationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function acceptInvite(): __PublicMethodMetaInfo<
  'POST',
  { joinApplicationId: string },
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.AcceptInviteRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.AcceptInviteRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.AcceptInviteResponse,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.AcceptInviteResponse
> {
  const payload = { joinApplicationId: ':joinApplicationId' } as any;

  const getRequestOptions =
    ambassadorWixOnlineProgramsParticipantsV3JoinApplication.acceptInvite(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/join-applications/{joinApplicationId}/accept-invite',
    pathParams: { joinApplicationId: 'joinApplicationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateJoinApplicationTags(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.BulkUpdateJoinApplicationTagsRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.BulkUpdateJoinApplicationTagsRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.BulkUpdateJoinApplicationTagsResponse,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.BulkUpdateJoinApplicationTagsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixOnlineProgramsParticipantsV3JoinApplication.bulkUpdateJoinApplicationTags(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/join-applications/update-tags',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateJoinApplicationTagsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.BulkUpdateJoinApplicationTagsByFilterRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.BulkUpdateJoinApplicationTagsByFilterRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.BulkUpdateJoinApplicationTagsByFilterResponse,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.BulkUpdateJoinApplicationTagsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixOnlineProgramsParticipantsV3JoinApplication.bulkUpdateJoinApplicationTagsByFilter(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/join-applications/update-tags-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function preparePayment(): __PublicMethodMetaInfo<
  'POST',
  { joinApplicationId: string },
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.PreparePaymentRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.PreparePaymentRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.PreparePaymentResponse,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.PreparePaymentResponse
> {
  const payload = { joinApplicationId: ':joinApplicationId' } as any;

  const getRequestOptions =
    ambassadorWixOnlineProgramsParticipantsV3JoinApplication.preparePayment(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/join-applications/{joinApplicationId}/prepare-payment',
    pathParams: { joinApplicationId: 'joinApplicationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function applyCoupon(): __PublicMethodMetaInfo<
  'POST',
  { joinApplicationId: string },
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.ApplyCouponRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.ApplyCouponRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.ApplyCouponResponse,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.ApplyCouponResponse
> {
  const payload = { joinApplicationId: ':joinApplicationId' } as any;

  const getRequestOptions =
    ambassadorWixOnlineProgramsParticipantsV3JoinApplication.applyCoupon(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/join-applications/{joinApplicationId}/apply-coupon',
    pathParams: { joinApplicationId: 'joinApplicationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function removeCoupon(): __PublicMethodMetaInfo<
  'POST',
  { joinApplicationId: string },
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.RemoveCouponRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.RemoveCouponRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.RemoveCouponResponse,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.RemoveCouponResponse
> {
  const payload = { joinApplicationId: ':joinApplicationId' } as any;

  const getRequestOptions =
    ambassadorWixOnlineProgramsParticipantsV3JoinApplication.removeCoupon(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/join-applications/{joinApplicationId}/remove-coupon',
    pathParams: { joinApplicationId: 'joinApplicationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function completeFreeCouponPayment(): __PublicMethodMetaInfo<
  'POST',
  { joinApplicationId: string },
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.CompleteFreeCouponPaymentRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.CompleteFreeCouponPaymentRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.CompleteFreeCouponPaymentResponse,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.CompleteFreeCouponPaymentResponse
> {
  const payload = { joinApplicationId: ':joinApplicationId' } as any;

  const getRequestOptions =
    ambassadorWixOnlineProgramsParticipantsV3JoinApplication.completeFreeCouponPayment(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/join-applications/{joinApplicationId}/complete-free-coupon-payment',
    pathParams: { joinApplicationId: 'joinApplicationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkInviteMembersToProgramByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.BulkInviteMembersToProgramByFilterRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.BulkInviteMembersToProgramByFilterRequest,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationUniversalTypes.BulkInviteMembersToProgramByFilterResponse,
  ambassadorWixOnlineProgramsParticipantsV3JoinApplicationTypes.BulkInviteMembersToProgramByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixOnlineProgramsParticipantsV3JoinApplication.bulkInviteMembersToProgramByFilter(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/join-applications/invite-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  JoinApplication as JoinApplicationOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  PaymentStatus as PaymentStatusOriginal,
  PaymentStatusWithLiterals as PaymentStatusWithLiteralsOriginal,
  PaymentInfo as PaymentInfoOriginal,
  Member as MemberOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  Tags as TagsOriginal,
  TagList as TagListOriginal,
  ReindexMessage as ReindexMessageOriginal,
  ReindexMessageActionOneOf as ReindexMessageActionOneOfOriginal,
  Upsert as UpsertOriginal,
  Delete as DeleteOriginal,
  Schema as SchemaOriginal,
  JoinApplicationTagsModified as JoinApplicationTagsModifiedOriginal,
  StatusChanged as StatusChangedOriginal,
  PaymentStatusChanged as PaymentStatusChangedOriginal,
  CreateJoinApplicationRequest as CreateJoinApplicationRequestOriginal,
  CreateJoinApplicationResponse as CreateJoinApplicationResponseOriginal,
  GetJoinApplicationRequest as GetJoinApplicationRequestOriginal,
  GetJoinApplicationResponse as GetJoinApplicationResponseOriginal,
  DeleteJoinApplicationRequest as DeleteJoinApplicationRequestOriginal,
  DeleteJoinApplicationResponse as DeleteJoinApplicationResponseOriginal,
  QueryJoinApplicationsRequest as QueryJoinApplicationsRequestOriginal,
  QueryV2 as QueryV2Original,
  QueryV2PagingMethodOneOf as QueryV2PagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  Paging as PagingOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryJoinApplicationsResponse as QueryJoinApplicationsResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  SearchJoinApplicationsRequest as SearchJoinApplicationsRequestOriginal,
  CursorSearch as CursorSearchOriginal,
  CursorSearchPagingMethodOneOf as CursorSearchPagingMethodOneOfOriginal,
  Aggregation as AggregationOriginal,
  AggregationKindOneOf as AggregationKindOneOfOriginal,
  RangeBucket as RangeBucketOriginal,
  SortType as SortTypeOriginal,
  SortTypeWithLiterals as SortTypeWithLiteralsOriginal,
  SortDirection as SortDirectionOriginal,
  SortDirectionWithLiterals as SortDirectionWithLiteralsOriginal,
  MissingValues as MissingValuesOriginal,
  MissingValuesWithLiterals as MissingValuesWithLiteralsOriginal,
  IncludeMissingValuesOptions as IncludeMissingValuesOptionsOriginal,
  ScalarType as ScalarTypeOriginal,
  ScalarTypeWithLiterals as ScalarTypeWithLiteralsOriginal,
  ValueAggregation as ValueAggregationOriginal,
  ValueAggregationOptionsOneOf as ValueAggregationOptionsOneOfOriginal,
  NestedAggregationType as NestedAggregationTypeOriginal,
  NestedAggregationTypeWithLiterals as NestedAggregationTypeWithLiteralsOriginal,
  RangeAggregation as RangeAggregationOriginal,
  ScalarAggregation as ScalarAggregationOriginal,
  DateHistogramAggregation as DateHistogramAggregationOriginal,
  Interval as IntervalOriginal,
  IntervalWithLiterals as IntervalWithLiteralsOriginal,
  NestedAggregationItem as NestedAggregationItemOriginal,
  NestedAggregationItemKindOneOf as NestedAggregationItemKindOneOfOriginal,
  AggregationType as AggregationTypeOriginal,
  AggregationTypeWithLiterals as AggregationTypeWithLiteralsOriginal,
  NestedAggregation as NestedAggregationOriginal,
  SearchDetails as SearchDetailsOriginal,
  Mode as ModeOriginal,
  ModeWithLiterals as ModeWithLiteralsOriginal,
  SearchJoinApplicationsResponse as SearchJoinApplicationsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  AggregationData as AggregationDataOriginal,
  ValueAggregationResult as ValueAggregationResultOriginal,
  RangeAggregationResult as RangeAggregationResultOriginal,
  NestedAggregationResults as NestedAggregationResultsOriginal,
  NestedAggregationResultsResultOneOf as NestedAggregationResultsResultOneOfOriginal,
  ValueResults as ValueResultsOriginal,
  RangeResults as RangeResultsOriginal,
  AggregationResultsScalarResult as AggregationResultsScalarResultOriginal,
  NestedValueAggregationResult as NestedValueAggregationResultOriginal,
  ValueResult as ValueResultOriginal,
  RangeResult as RangeResultOriginal,
  ScalarResult as ScalarResultOriginal,
  NestedResultValue as NestedResultValueOriginal,
  NestedResultValueResultOneOf as NestedResultValueResultOneOfOriginal,
  Results as ResultsOriginal,
  DateHistogramResult as DateHistogramResultOriginal,
  GroupByValueResults as GroupByValueResultsOriginal,
  DateHistogramResults as DateHistogramResultsOriginal,
  NestedResults as NestedResultsOriginal,
  AggregationResults as AggregationResultsOriginal,
  AggregationResultsResultOneOf as AggregationResultsResultOneOfOriginal,
  BulkCreateJoinApplicationsRequest as BulkCreateJoinApplicationsRequestOriginal,
  BulkCreateJoinApplicationsResponse as BulkCreateJoinApplicationsResponseOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkJoinApplicationResult as BulkJoinApplicationResultOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  BulkUpsertJoinApplicationMigrationRequest as BulkUpsertJoinApplicationMigrationRequestOriginal,
  JoinApplicationMigration as JoinApplicationMigrationOriginal,
  BulkUpsertJoinApplicationMigrationResponse as BulkUpsertJoinApplicationMigrationResponseOriginal,
  BulkJoinApplicationMigrationResult as BulkJoinApplicationMigrationResultOriginal,
  BulkActionType as BulkActionTypeOriginal,
  BulkActionTypeWithLiterals as BulkActionTypeWithLiteralsOriginal,
  BulkDeleteJoinApplicationsRequest as BulkDeleteJoinApplicationsRequestOriginal,
  BulkDeleteJoinApplicationsResponse as BulkDeleteJoinApplicationsResponseOriginal,
  BulkDeleteJoinApplicationsResponseBulkJoinApplicationResult as BulkDeleteJoinApplicationsResponseBulkJoinApplicationResultOriginal,
  GetCurrentJoinApplicationRequest as GetCurrentJoinApplicationRequestOriginal,
  GetCurrentJoinApplicationResponse as GetCurrentJoinApplicationResponseOriginal,
  MyJoinApplicationRequest as MyJoinApplicationRequestOriginal,
  MyJoinApplicationResponse as MyJoinApplicationResponseOriginal,
  ApproveJoinApplicationRequest as ApproveJoinApplicationRequestOriginal,
  ApproveJoinApplicationResponse as ApproveJoinApplicationResponseOriginal,
  DeclineJoinApplicationRequest as DeclineJoinApplicationRequestOriginal,
  DeclineJoinApplicationResponse as DeclineJoinApplicationResponseOriginal,
  CancelJoinApplicationRequest as CancelJoinApplicationRequestOriginal,
  CancelJoinApplicationResponse as CancelJoinApplicationResponseOriginal,
  AcceptInviteRequest as AcceptInviteRequestOriginal,
  AcceptInviteResponse as AcceptInviteResponseOriginal,
  BulkUpdateJoinApplicationTagsRequest as BulkUpdateJoinApplicationTagsRequestOriginal,
  BulkUpdateJoinApplicationTagsResponse as BulkUpdateJoinApplicationTagsResponseOriginal,
  BulkUpdateJoinApplicationTagsResult as BulkUpdateJoinApplicationTagsResultOriginal,
  BulkUpdateJoinApplicationTagsByFilterRequest as BulkUpdateJoinApplicationTagsByFilterRequestOriginal,
  BulkUpdateJoinApplicationTagsByFilterResponse as BulkUpdateJoinApplicationTagsByFilterResponseOriginal,
  PreparePaymentRequest as PreparePaymentRequestOriginal,
  PaymentType as PaymentTypeOriginal,
  PaymentTypeWithLiterals as PaymentTypeWithLiteralsOriginal,
  PreparePaymentResponse as PreparePaymentResponseOriginal,
  ApplyCouponRequest as ApplyCouponRequestOriginal,
  ApplyCouponResponse as ApplyCouponResponseOriginal,
  RemoveCouponRequest as RemoveCouponRequestOriginal,
  RemoveCouponResponse as RemoveCouponResponseOriginal,
  CompleteFreeCouponPaymentRequest as CompleteFreeCouponPaymentRequestOriginal,
  CompleteFreeCouponPaymentResponse as CompleteFreeCouponPaymentResponseOriginal,
  BulkInviteMembersToProgramByFilterRequest as BulkInviteMembersToProgramByFilterRequestOriginal,
  BulkInviteMembersToProgramByFilterResponse as BulkInviteMembersToProgramByFilterResponseOriginal,
  DeleteAllJoinApplicationsMigrationRequest as DeleteAllJoinApplicationsMigrationRequestOriginal,
  DeleteAllJoinApplicationsMigrationResponse as DeleteAllJoinApplicationsMigrationResponseOriginal,
  ReindexJoinApplicationsSearchRequest as ReindexJoinApplicationsSearchRequestOriginal,
  ReindexJoinApplicationsSearchResponse as ReindexJoinApplicationsSearchResponseOriginal,
  SyncPaymentExpirationTasksMigrationRequest as SyncPaymentExpirationTasksMigrationRequestOriginal,
  SyncPaymentExpirationTasksMigrationResponse as SyncPaymentExpirationTasksMigrationResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  PaymentEvent as PaymentEventOriginal,
  PaymentEventEventOneOf as PaymentEventEventOneOfOriginal,
  EventType as EventTypeOriginal,
  EventTypeWithLiterals as EventTypeWithLiteralsOriginal,
  TransactionStatusChangedEvent as TransactionStatusChangedEventOriginal,
  Order as OrderOriginal,
  OrderItem as OrderItemOriginal,
  OrderItemCategory as OrderItemCategoryOriginal,
  OrderItemCategoryWithLiterals as OrderItemCategoryWithLiteralsOriginal,
  OrderAdditionalCharges as OrderAdditionalChargesOriginal,
  Address as AddressOriginal,
  AddressStreetOneOf as AddressStreetOneOfOriginal,
  StreetAddress as StreetAddressOriginal,
  AddressLocation as AddressLocationOriginal,
  Subdivision as SubdivisionOriginal,
  SubdivisionType as SubdivisionTypeOriginal,
  SubdivisionTypeWithLiterals as SubdivisionTypeWithLiteralsOriginal,
  StandardDetails as StandardDetailsOriginal,
  FullAddressContactDetails as FullAddressContactDetailsOriginal,
  VatId as VatIdOriginal,
  VatType as VatTypeOriginal,
  VatTypeWithLiterals as VatTypeWithLiteralsOriginal,
  Transaction as TransactionOriginal,
  TransactionPaymentMethodDataOneOf as TransactionPaymentMethodDataOneOfOriginal,
  CurrencyAmount as CurrencyAmountOriginal,
  TransactionStatus as TransactionStatusOriginal,
  TransactionStatusWithLiterals as TransactionStatusWithLiteralsOriginal,
  RecurringPaymentDetails as RecurringPaymentDetailsOriginal,
  CreditCardPaymentMethodData as CreditCardPaymentMethodDataOriginal,
  V3AccountInfo as V3AccountInfoOriginal,
  ScheduledAction as ScheduledActionOriginal,
  ScheduledActionType as ScheduledActionTypeOriginal,
  ScheduledActionTypeWithLiterals as ScheduledActionTypeWithLiteralsOriginal,
  RefundStatusChangedEvent as RefundStatusChangedEventOriginal,
  Refund as RefundOriginal,
  RefundStatus as RefundStatusOriginal,
  RefundStatusWithLiterals as RefundStatusWithLiteralsOriginal,
  RecurringPaymentStatusChangedEvent as RecurringPaymentStatusChangedEventOriginal,
  RecurringPaymentStatusStatus as RecurringPaymentStatusStatusOriginal,
  RecurringPaymentStatusStatusWithLiterals as RecurringPaymentStatusStatusWithLiteralsOriginal,
  RecurringPaymentCancellationDetails as RecurringPaymentCancellationDetailsOriginal,
  Initiator as InitiatorOriginal,
  InitiatorWithLiterals as InitiatorWithLiteralsOriginal,
  TransactionUpdatedEvent as TransactionUpdatedEventOriginal,
  TransactionCreatedEvent as TransactionCreatedEventOriginal,
  BenefitNotification as BenefitNotificationOriginal,
  Benefit as BenefitOriginal,
  EntryPass as EntryPassOriginal,
  Discount as DiscountOriginal,
  DiscountDiscountOneOf as DiscountDiscountOneOfOriginal,
  BenefitType as BenefitTypeOriginal,
  BenefitTypeWithLiterals as BenefitTypeWithLiteralsOriginal,
  Behavior as BehaviorOriginal,
  BehaviorBehaviorOneOf as BehaviorBehaviorOneOfOriginal,
  Event as EventOriginal,
  EventWithLiterals as EventWithLiteralsOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  CreateJoinApplicationApplicationErrors as CreateJoinApplicationApplicationErrorsOriginal,
  BulkCreateJoinApplicationsApplicationErrors as BulkCreateJoinApplicationsApplicationErrorsOriginal,
  GetCurrentJoinApplicationApplicationErrors as GetCurrentJoinApplicationApplicationErrorsOriginal,
  MyJoinApplicationApplicationErrors as MyJoinApplicationApplicationErrorsOriginal,
  ApproveJoinApplicationApplicationErrors as ApproveJoinApplicationApplicationErrorsOriginal,
  DeclineJoinApplicationApplicationErrors as DeclineJoinApplicationApplicationErrorsOriginal,
  CancelJoinApplicationApplicationErrors as CancelJoinApplicationApplicationErrorsOriginal,
  AcceptInviteApplicationErrors as AcceptInviteApplicationErrorsOriginal,
  BulkUpdateJoinApplicationTagsApplicationErrors as BulkUpdateJoinApplicationTagsApplicationErrorsOriginal,
  BulkUpdateJoinApplicationTagsByFilterApplicationErrors as BulkUpdateJoinApplicationTagsByFilterApplicationErrorsOriginal,
  PreparePaymentApplicationErrors as PreparePaymentApplicationErrorsOriginal,
  ApplyCouponApplicationErrors as ApplyCouponApplicationErrorsOriginal,
  RemoveCouponApplicationErrors as RemoveCouponApplicationErrorsOriginal,
  CompleteFreeCouponPaymentApplicationErrors as CompleteFreeCouponPaymentApplicationErrorsOriginal,
  BulkInviteMembersToProgramByFilterApplicationErrors as BulkInviteMembersToProgramByFilterApplicationErrorsOriginal,
} from './online-programs-participants-v3-join-application-join-applications.types.js';
